const colors = {
  deepblue: "#3f6eb5",
  lightblue: "#414C83",
  lightred: "#D95151",
};

export default colors;
